import { withTableView } from '@components/enitity/table/Table.view'
import { useTranslation } from 'react-i18next'

import { BankNotificationsTable } from '../../components/BankNotificationsTable'

export const BankNotifications = () => {
  const { t } = useTranslation('banking')
  const TableWithView = withTableView(BankNotificationsTable, t('title'))
  return <TableWithView />
}
